import { ApplicationInsights } from '@microsoft/applicationinsights-web';

class TelemetryService {
  public appInsights: ApplicationInsights;

  public initialize(key: string) {
    if (key) {
      const INSTRUMENTATION_KEY = key;

      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: INSTRUMENTATION_KEY,
        },
      });
      this.appInsights.loadAppInsights();
    }
  }
}

const ai = new TelemetryService();

export { ai };
export default ai;
